import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,
        private authService: AuthenticationService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const user = this.authService.getCurrentUser();
        if (user && user.expiration) {
            if (new Date() < new Date(user.expiration)) {
                if (next) {
                    const roles = next.data['roles'];
                    let hasRoles = roles ? this.authService.hasAnyRole(roles) : true;
                    if (!hasRoles) {
                        this.router.navigate(['/']);
                        return false;
                    }
                }

                return true;
            } else {
                this.authService.logout(true);
                this.router.navigate(['auth/login'], { queryParams: { redirectUrl: state.url } });
                return false;
            }
        }

        this.router.navigate(['auth/login'], { queryParams: { redirectUrl: state.url } });
        return false;
    }
}
